import React, { useState } from 'react';
import styled from 'styled-components';
import { isNotEmpty } from '../../utils/validator';

interface Props {
	simName: string;
	onChange: (value: string) => void;
}

const ErrorMessage = styled.div`
	color: red;
`;

export const SimNameForm: React.FC<Props> = (props: Props) => {
	const [showError, setShowError] = useState<boolean>(false);

	const onSimNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (isNotEmpty(e.target.value)) {
			setShowError(false);
			props.onChange(e.target.value);
		} else {
			setShowError(true);
		}
	};

	return (
		<React.Fragment>
			<form>
				<label htmlFor="simName">Simmin nimi</label>
				<input type="text" defaultValue={props.simName} onChange={onSimNameChange} />
			</form>
			{showError && <ErrorMessage>Tarkista kenttä</ErrorMessage>}
		</React.Fragment>
	);
};
